import React from 'react';
import './Terms.css'; // Opcional si deseas mover los estilos a un archivo CSS

const Terms: React.FC = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="ip-logo">
          <div className="rounded" style={{ width: '150px', margin: '0 auto' }}>
            <img src="/assets/logo_black.png" alt="logo broadcast" />
          </div>
        </div>
      </header>

      <div className="container">
        <h1 style={{ fontSize: '25px', margin: 0 }}>Términos y condiciones del servicio</h1>
        <h4 style={{ margin: 0 }}>Fecha de entrada en vigor: 01-01-2024</h4>
        <br />
        <h2 style={{ fontSize: '20px', margin: 0 }}>
          Bienvenido a <strong>IP Broadcast</strong>
        </h2>
        <p>Al acceder y utilizar nuestra Plataforma, aceptas los siguientes términos y condiciones:</p>

        {[
          {
            title: '1. Uso de la Plataforma',
            items: [
              'Al utilizar la Plataforma, aceptas cumplir con todas las leyes y regulaciones aplicables.',
              'No puedes utilizar la Plataforma con fines ilegales o no autorizados.',
            ],
          },
          {
            title: '2. Contenido de la Plataforma',
            items: [
              'IP Broadcast se reserva el derecho de modificar o eliminar cualquier contenido que viole estos términos.',
              'IP Broadcast no garantiza la precisión, integridad o actualidad del contenido proporcionado a través de la Plataforma.',
            ],
          },
          {
            title: '3. Propiedad Intelectual',
            items: [
              'IP Broadcast posee todos los derechos de propiedad intelectual asociados con la Plataforma y su contenido.',
              'No puedes reproducir, distribuir o utilizar de otra manera el contenido de la Plataforma sin el consentimiento expreso de IP Broadcast.',
            ],
          },
          {
            title: '4. Privacidad',
            items: [
              'La información recopilada por la Plataforma se maneja de acuerdo con nuestra Política de Privacidad.',
            ],
          },
          {
            title: '5. Limitación de Responsabilidad',
            items: [
              'IP Broadcast no será responsable de ningún daño directo, indirecto, incidental, especial o consecuente derivado del uso o la imposibilidad de usar la Plataforma.',
            ],
          },
          {
            title: '6. Modificaciones y Terminación',
            items: [
              'IP Broadcast se reserva el derecho de modificar o interrumpir la Plataforma en cualquier momento sin previo aviso.',
              'IP Broadcast puede suspender o cerrar tu cuenta si violas estos términos.',
            ],
          },
          {
            title: '7. Ley Aplicable',
            items: [
              'Estos términos se rigen por las leyes del Perú sin tener en cuenta sus conflictos de principios legales.',
            ],
          },
          {
            title: '8. Política Contra el Uso de Mensajes No Solicitados',
            items: [
              'Prohibimos estrictamente el uso de mensajes no solicitados, incluidos, entre otros, correos electrónicos, mensajes de texto y mensajes instantáneos, para promocionar nuestro sitio web (ipnoticias.com) o cualquiera de los servicios que ofrece nuestra organización.',
              'Todos los afiliados, socios, contratistas y proveedores externos que trabajen con IP Broadcast deben cumplir con esta política. Está estrictamente prohibido que se involucren en el envío de mensajes no solicitados en nuestro nombre.',
              'Supervisamos activamente todas las actividades publicitarias realizadas en nombre de nuestra organización. Cualquier afiliado o tercero que incumpla esta política estará sujeto a la terminación inmediata de su acuerdo.',
              'IP Broadcast se comunica exclusivamente con clientes autorizados e individuos que han optado explícitamente por recibir nuestros servicios.',
            ],
          },
        ].map((section, idx) => (
          <div key={idx} className="section">
            <div className="section-title">{section.title}</div>
            <ol>
              {section.items.map((text, i) => (
                <li key={i}>
                  <strong>{`${idx + 1}.${i + 1}`}</strong> {text}
                </li>
              ))}
            </ol>
          </div>
        ))}

        <p>
          Al utilizar la Plataforma, aceptas estos términos. Si no estás de acuerdo con estos términos, por favor, no
          uses la Plataforma.
        </p>
      </div>

      <footer className="footer">
        <p>© 2025 IP Broadcast. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default Terms;
